
import "../clients/clients";
import "./supplier.scss";

import { useNavigate } from "react-router-dom";
import CardListHorizontal from "../../../components/card-list-horizontal";
import SkeletonLine from "../../../components/skeleton/SkeletonLine";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { useEffect } from "react";
import { fetchSuppliers } from "../../../store/OrganizationSlice";
import ModalAddSupplier from "../../../components/modal/modal-add-supplier/modalAddSupplier";
import { setSupplierModalStatus } from "../../../store/SuppliersSlice";

const Supplier = () => {

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const goToUrl = (url:string) => {
        navigate('/clients/'+url);
    }

    const suppliers     = useAppSelector( (state) => state.supplier.suppliersOrganization )
    const modalStatus   = useAppSelector( (state) => state.supplier.modalStatus )

    useEffect( () => {
        dispatch(fetchSuppliers());
    }, [dispatch])

    const toggle = () => {
        dispatch(setSupplierModalStatus(!modalStatus))
    }

    return (
        <>
            <div className="client-wrapper supplier-wrapper">
                
                <h1 className="page-title">
                    <div className="text">
                        Lista de Forncedores
                        <small>lista de fornecedores cadastrados e suas respectivas informações, carteiras e seus valores.</small>
                    </div>
                    <div className="buttons">
                        <div className="btn purple" onClick={toggle}>
                            Adicionar Fornecedor
                        </div>
                    </div>
                </h1>

                <hr />
                
                { !suppliers && <SkeletonLine height="40" /> }
                { suppliers && <CardListHorizontal items={suppliers} showDeposits={false} /> }
                
            </div>
            { modalStatus && <ModalAddSupplier click={toggle}/>}
        </>
    );
}

export default Supplier;